import { Routes } from '@angular/router';
import { OfflineStoresEnabledGuard } from '@/shared/guards/offline-stores-enabled.guard';

export const orderRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('./orders-table/orders-table.component').then((m) => m.OrdersTableComponent),
  },
  {
    // CRAT-1127 — manual offline-store order (POS). Gated on the offline-stores tier flag.
    path: 'create',
    canActivate: [OfflineStoresEnabledGuard],
    loadComponent: () =>
      import('./create-order-page/create-order-page.component').then((m) => m.CreateOrderPageComponent),
  },
  {
    path: 'order/:id',
    loadComponent: () =>
      import('../packing/packing-order/packing-order.component').then((m) => m.PackingOrderComponent),
  },
];
